import { Component, EventEmitter, Inject, Input, OnInit, Output, Pipe } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import moment, { Moment } from 'moment';


export const MONTH_YEAR_FORMAT = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface FiltroConfig {
  id: number; // identificador del filtro
  label: string;
  labelEnd?: string;
  key: string; // nombre de la variable que guardarás
  tipo: 'input' | 'select' | 'date-range' | 'departamento' | 'cities';
  opciones?: { value: string; label: string }[]; // solo si es select
}


@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMAT },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    }
  ]
})

export class FiltersComponent implements OnInit {
  opcionesFiltradas: { [key: string]: any[] } = {};
  mostrarLista: { [key: string]: boolean } = {};
  minMonthDate!: Moment;
  maxMonthDate!: Moment;
  yearFilter = (date: Moment | null): boolean => {
    if (!date) return false;

    return date.isSameOrAfter(this.minMonthDate, 'year')
      && date.isSameOrBefore(this.maxMonthDate, 'year');
  };

  dateRangeRequiredError: { [key: string]: boolean } = {};
  dateRangeError: { [key: string]: boolean } = {};
  @Input() filtrosConfig: any[] = [];
  @Output() ejecutarAccion = new EventEmitter<any>();
  filtros: any = {};
  searchCod: string = '';
  searchDepa: string = '';
  searchCity: string = '';
  searchEPS: string = '';
  searchCodName = '';
  searchPro = '';

  constructor() {

  }

  ngOnInit(): void {
    const currentYear = moment().year();

    this.minMonthDate = moment([2024, 0, 1]);
    this.maxMonthDate = moment([currentYear + 3, 11, 1]);

    const tiposConControl = ['select-cod-medicamentos-query', 'select-eps', 'select-cod-servicio', 'select-cod-medicamentos', 'select-depa', 'select-city'];

    this.filtrosConfig.forEach(filtro => {
      filtro.busqueda = '';
      filtro.opcionesFiltradas = [...(filtro.opciones || [])];
      if (tiposConControl.includes(filtro.tipo) && !filtro.control) {
        filtro.control = new FormControl('');
      }
    });

  }

  onAutocompleteSelected(filtro: any) {
    const selected = filtro.control.value;
    this.filtros[filtro.key] = selected;
  }

  aplicarFiltros(): void {
    const filtrosLimpios: any[] = [];
    this.filtrosConfig.forEach(f => {
      if (f.tipo === 'date-range') {
        const desde = this.filtros[f.key + 'Desde'];
        const hasta = this.filtros[f.key + 'Hasta'];

        if (desde || hasta) {
          filtrosLimpios.push({
            id: f.id,
            key: f.key,
            valueDesde: desde ? this.formatDate(desde) : null,
            valueHasta: hasta ? this.formatDate(hasta) : null
          });
        }
      } else {
        const valor = this.filtros[f.key];
        if (valor !== null && valor !== undefined && valor !== '') {
          filtrosLimpios.push({
            id: f.id,
            key: f.key,
            value: valor
          });
        }
      }
    });

    this.ejecutarAccion.emit(filtrosLimpios);
  }


  private formatDate(date: any): string {
    return date ? date.format('MM/YYYY') : '';
  }


  cancelar(): void {
    // this.dialogRef.close(null);
  }

  transform(options: any[], search: string): any[] {
    if (!options || !search) return options;
    return options.filter(opt =>
      opt.cod.toLowerCase().includes(search.toLowerCase())
    );
  }

  onInputKeydown(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.stopPropagation(); // ⛔ evita que cierre el select
      // NO pongas preventDefault aquí
    }
  }


  limpiarFiltros(): void {
    const tiposConControl = [
      'select-cod-medicamentos-query',
      'select-eps',
      'select-cod-servicio',
      'select-cod-medicamentos',
      'select-depa',
      'select-city'
    ];

    this.filtrosConfig.forEach(filtro => {
      // Limpiar búsqueda interna si aplica
      if ('busqueda' in filtro) {
        filtro.busqueda = '';
      }

      // Restaurar lista filtrada
      filtro.opcionesFiltradas = [...(filtro.opciones || [])];

      // Resetear control reactivo
      if (tiposConControl.includes(filtro.tipo)) {
        if (!filtro.control) {
          filtro.control = new FormControl('');
        } else {
          if (filtro.control) {
            filtro.control.reset();
          } else {
            console.warn('Control no definido para filtro', filtro.key);
          }
        }
      }
    });

    // Limpiar filtros simples (inputs y selects tradicionales)
    for (const key in this.filtros) {
      if (this.filtros.hasOwnProperty(key)) {
        this.filtros[key] = '';
      }
    }

    // Variables auxiliares
    this.searchCod = '';
    this.searchCodName = '';
    this.searchEPS = '';
    this.searchPro = '';
    this.searchCity='';
    this.searchDepa='';
  }
  onMonthSelected(
    month: Moment,
    key: string,
    tipo: 'Desde' | 'Hasta',
    picker: any
  ): void {

    // 👇 Normalizamos al día 1 del mes seleccionado
    const normalizedMonth = month.clone().startOf('month');

    this.filtros[key + tipo] = normalizedMonth;

    picker.close();

    this.validarRangoFechas(key);
  }

  private validarRangoFechas(key: string): void {
    const desde = this.filtros[key + 'Desde'];
    const hasta = this.filtros[key + 'Hasta'];

    // ❌ Si solo uno está diligenciado
    this.dateRangeRequiredError[key] =
      (desde && !hasta) || (!desde && hasta);

    // ❌ Si ambos existen, validar orden
    if (desde && hasta) {
      this.dateRangeError[key] = hasta.isBefore(desde);
    } else {
      this.dateRangeError[key] = false;
    }
  }

  tieneErroresFecha(): boolean {
    return Object.values(this.dateRangeError).some(v => v);
  }




  filtrarEPS(key: string, search: string, opciones: any[]) {
    if (!search || !opciones) {
      this.opcionesFiltradas[key] = [];
      return;
    }

    const filtro = search.toLowerCase();
    this.opcionesFiltradas[key] = opciones.filter(opt =>
      opt.nameEPS.toLowerCase().includes(filtro)
    );
  }

  seleccionarEPS(key: string, opcion: any) {
    this.filtros[key] = opcion.id; // 👉 o solo `opcion.id` si prefieres guardar el ID
    this.mostrarLista[key] = false;
  }

  ocultarListaConRetraso(key: string) {
    setTimeout(() => {
      this.mostrarLista[key] = false;
    }, 200);
  }

  onInputChange(valor: string, filtro: any) {
    const encontrado = filtro.opciones.find((opt: any) => opt.medicamento === valor);
    if (encontrado) {
      this.filtros[filtro.key] = encontrado.medicamento;
    } else {
      this.filtros[filtro.key] = null; // O mantener el valor anterior
    }
  }

  filtrarOpciones(filtro: any): void {
    const texto = filtro.busqueda?.toLowerCase() || '';
    filtro.opcionesFiltradas = filtro.opciones.filter((opt: any) =>
      opt.nameEPS.toLowerCase().includes(texto)
    );
  }
  filtrarOpcionesDepartamentos(filtro: any): void {
    const texto = filtro.busqueda?.toLowerCase() || '';

    filtro.opcionesFiltradas = (filtro.opciones || []).filter((opt: any) =>
      opt.nombre.toLowerCase().includes(texto)
    );
  }
  filtrarOpcionesCiudad(filtro: any): void {
    const texto = filtro.busqueda?.toLowerCase() || '';

    filtro.opcionesFiltradas = (filtro.opciones || []).filter((opt: any) =>
      opt.ciudad.toLowerCase().includes(texto)
    );
  }
  filtrarOpcionesMedicamentos(filtro: any): void {
    const texto = filtro.busqueda?.toLowerCase() || '';
    filtro.opcionesFiltradas = (filtro.opciones || []).filter((opt: any) =>
      opt.medicamento.toLowerCase().includes(texto)
    );
  }

  filtrarOpcionesMedicamentosCod(filtro: any): void {
    const texto = filtro.busqueda?.toLowerCase() || '';
    filtro.opcionesFiltradas = (filtro.opciones || []).filter((opt: any) =>
      opt.medicamento.toLowerCase().includes(texto)
    );
  }
  reset(): void {
    const tiposConControl = [
      'select-cod-medicamentos-query',
      'select-eps',
      'select-cod-servicio',
      'select-cod-medicamentos',
      'select-depa'
    ];

    // 1️⃣ Limpiar modelo lógico
    this.filtros = {};
    this.dateRangeError = {};

    // 2️⃣ Resetear cada filtro
    this.filtrosConfig.forEach(filtro => {

      // Limpiar texto de búsqueda
      filtro.busqueda = '';

      // Restaurar opciones
      filtro.opcionesFiltradas = [...(filtro.opciones || [])];

      // Resetear controles reactivos
      if (tiposConControl.includes(filtro.tipo)) {
        if (filtro.control) {
          filtro.control.setValue(null); // 👈 CLAVE
          filtro.control.reset();
          filtro.control.markAsPristine();
          filtro.control.markAsUntouched();
        }
      }
    });

    // 3️⃣ Limpiar variables auxiliares
    this.searchCod = '';
    this.searchCodName = '';
    this.searchEPS = '';
    this.searchPro = '';
    this.searchDepa = '';
    this.searchCity = '';
    // 4️⃣ Forzar refresco visual (Material hack)
    setTimeout(() => { }, 0);
  }
  getDepartamento(dep: string): string {
    return dep?.replace(/\s*\(.*?\)/g, '') ?? dep;
  }

}